/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * Defines icon categories for activity log entries.
Each category maps to a specific icon and styling in the UI.1 = Created

2 = Updated

3 = Sent

4 = Approved

5 = Success

6 = Declined

7 = Failed

8 = ReadyForPayment

9 = Paid

10 = Pending

11 = Processing

12 = SyncedToAccounting

13 = Closed

14 = ForReview

15 = AssignedTo

16 = Voided

17 = ChangesRequested

18 = DocumentSubmitted

19 = DocumentChangesRequested

20 = Published

21 = RevisionRequested

22 = Returned

23 = Incomplete

24 = Removed

25 = Resent


 */
export type ActivityLogIconCategory =
  (typeof ActivityLogIconCategory)[keyof typeof ActivityLogIconCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActivityLogIconCategory = {
  Created: 1,
  Updated: 2,
  Sent: 3,
  Approved: 4,
  Success: 5,
  Declined: 6,
  Failed: 7,
  ReadyForPayment: 8,
  Paid: 9,
  Pending: 10,
  Processing: 11,
  SyncedToAccounting: 12,
  Closed: 13,
  ForReview: 14,
  AssignedTo: 15,
  Voided: 16,
  ChangesRequested: 17,
  DocumentSubmitted: 18,
  DocumentChangesRequested: 19,
  Published: 20,
  RevisionRequested: 21,
  Returned: 22,
  Incomplete: 23,
  Removed: 24,
  Resent: 25,
} as const;
